module.exports = __webpack_public_path__ + "img/banner_mobile.09369734.png";